import React, {useState} from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ChantierInfoPhoto from '../ChantierInfoPhoto/ChantierInfoPhoto';
import ChantierInfoGraph from '../ChantierInfoGraph/ChantierInfoGraph';
import ChantierInfoFacture from '../ChantierinfoFacture/ChantierInfoFacture';
import ChantierInfoNote from '../ChantierInfoNote/ChantierInfoNote';
import ChantierInfoCheckin from '../ChantierInfoCheckin/ChantierInfoCheckin';
import ChantierInfoHistorique from '../ChantierInfoHistorique/ChantierInfoHistorique';
import './ChantierInfoHeure.css';
import ChantierInfoFile from '../ChantierInfoFile/ChantierInfoFile';
import ToDoList from '../ChantierInfoToDoList/ToDoList';
import './ChantierInfo.css';
import {Row, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons';

/**
 * La vue d'un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierInfoView(props) {
  const [showDropdown, setShowDropdown] = useState(false);

  /**
   * Permet de gérer le dropdown
   * @param {*} event event
   */
  function toggleDropdown(event) {
    setShowDropdown(event.target.value);
    props.setWhatToShow(event.target.value);
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const windowWidth = window.innerWidth;
  const isMobile = windowWidth <= 600;

  return (
    <div className="chantierinfo-container">
      <h2 className="chantier-heading h2center">Projets: {props.chantierInfo.name || props.chantierInfo.client_name} </h2>
      <div className="chantierinfo-wrapper">
        <div className="chantierinfo-table">
          <Row className="chantierinfo-row chantierinfo-header">
            <Col md={5} className="chantierinfo-cell">
              Nom
            </Col>
            <Col md={5} className="chantierinfo-cell">
              Téléphone
            </Col>
            <Col md={2} className="chantierinfo-cell ">
              # Contrat
            </Col>
          </Row>
          <Row className="chantierinfo-row chantierinfo-row-cell-click">
            <Col
              md={5}
              className="chantierinfo-cell chantierinfo-cell-click"
              data-title="Nom du client">
              {props.chantierInfo.client_name}
            </Col>
            <Col
              md={5}
              className="chantierinfo-cell chantierinfo-cell-click"
              data-title="Téléphone">
              {props.chantierInfo.phone}
            </Col>
            <Col
              md={2}
              className="chantierinfo-cell chantierinfo-cell-click"
              data-title="# Contrat">
              {props.chantierInfo.contrat}
            </Col>
          </Row>
        </div>
      </div>
      <div className="buttons-container">
        {isMobile ? (
        <select
          value={showDropdown}
          onChange={(event) => {
            toggleDropdown(event);
          }}
          className="chantierinfo-mobile-select">
          <option value={1}>To-Do List</option>
          {localStorage.getItem('admin') === '1' &&
          <option value={2}>Check-in</option>}
          <option value={3}>Photos</option>
          <option value={4}>Factures</option>
          <option value={5}>PDF</option> 
          <option value={6}>Notes</option>
          {localStorage.getItem('admin') === '1' &&
          <option value={7}>Historique</option>}
          {localStorage.getItem('admin') === '1' &&
          <option value={8}>Graphique</option>}
        </select>
      ) : (
        <div className="chantierinfo-buttons2-container">
          <button
            className={props.whatToShow === '1' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={1}
            onClick={(event) => toggleDropdown(event)}>To-Do List</button>
          {localStorage.getItem('admin') === '1' ?
          <button
            className={props.whatToShow === '2' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={2}
            onClick={(event) => toggleDropdown(event)}>Check-in</button> : '' }
          <button
            className={props.whatToShow === '3' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={3}
            onClick={(event) => toggleDropdown(event)}>Photos</button>
          <button
            className={props.whatToShow === '4' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={4}
            onClick={(event) => toggleDropdown(event)}>Factures</button>
          <button
            className={props.whatToShow === '5' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={5}
            onClick={(event) => toggleDropdown(event)}>PDF</button>
          <button
            className={props.whatToShow === '6' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={6}
            onClick={(event) => toggleDropdown(event)}>Notes</button>
          {localStorage.getItem('admin') === '1' ?
            <button
              className={props.whatToShow === '7' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
              value={7}
              onClick={(event) => toggleDropdown(event)}>Historique</button> : '' }
          {localStorage.getItem('admin') === '1' ?
          <button
            className={props.whatToShow === '8' ? 'chantierinfo-button2selected' : 'chantierinfo-buttons2'}
            value={8}
            onClick={(event) => toggleDropdown(event)}>Graphique</button> : '' }
        </div>
      )}
      </div>

      {
       props.whatToShow === '1' ? <ToDoList/> :
       props.whatToShow === '2' ? <ChantierInfoCheckin/> :
       props.whatToShow === '3' ? <ChantierInfoPhoto/>:
       props.whatToShow === '4' ? <ChantierInfoFacture/>:
       props.whatToShow === '5' ? <ChantierInfoFile/>:
       props.whatToShow === '6' ? <ChantierInfoNote/>:
       props.whatToShow === '7' ? <ChantierInfoHistorique/>:
      <ChantierInfoGraph></ChantierInfoGraph>}

      <button className="chantierinfo-scroll-to-top-button" onClick={scrollToTop}>
        <FontAwesomeIcon icon={faArrowUp}></FontAwesomeIcon>
      </button>
    </div>
  );
}

export default ChantierInfoView;
